var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tab-container row"},_vm._l((_vm.tabs),function(tab,index){return _c('Tab',{key:index,attrs:{"label":tab.label,"isSelected":_vm.tabSelected == tab.slug},on:{"selectTab":function($event){return _vm.selectTab(tab.slug)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }